import * as Yup from 'yup';
import { Formik } from 'formik';
import React from 'react';
import { ModalComponent } from 'components/layout/modals/ModalComponent';
import { jobVacancyStore } from '../JobVacancyStore';

const ValidationSchema = Yup.object().shape({
	applicant: Yup.object().label('Applicant').nullable(),
	status: Yup.string().label('Status').required(),
	notes: Yup.string().label('Notes')
});

export class JobVacancyCreate extends ModalComponent {
	getInitialValues() {
		return {
			applicant: null,
			status: 'open',
			notes: ''
		};
	}

	render() {
		return (
			<Formik
				initialValues={this.getInitialValues()}
				validationSchema={ValidationSchema}
				onSubmit={values => {
					this.saving();
					this.create(values);
				}}>
				{formikBag =>
					this.renderModalContainer(
						{ ...formikBag, dirty: true },
						'JobVacancyCreate'
					)
				}
			</Formik>
		);
	}

	renderForm(formikBag) {
		return (
			<>
				<p className="subtitle is-6 ">
					You are creating a vacancy for <strong>{this.props.job.title}</strong>{' '}
					position in <strong>{this.props.job.client?.name}</strong> client.
				</p>
			</>
		);
	}

	async create(values) {
		jobVacancyStore
			.create({
				jobId: this.props.job.id,
				applicantId: values.applicant?.id,
				status: values.status,
				notes: values.notes
			})
			.then(result => {
				this.resultNotification(result, 'Job Vacancy', 'Create');
			});
	}
}
